<template>
  <el-dialog
    :visible.sync="showCompetition"
    width="65%"
    :append-to-body="true"
    @open="handleOpen"
    :modal-append-to-body="true"
    destroy-on-close
    title="发布赛吧"
    @closed="handleClose"
    :close-on-click-modal="false"
    class="competition-club-edit"
  >
    <el-form ref="form" :model="form" label-position="left" :rules="rules">
      <el-row :gutter="24">
        <el-col :span="10">
          <el-form-item label="赛事名称" style="display: flex;flex-direction: column" prop="title">
            <el-input v-model="form.title" size="mini" placeholder="请输入赛事名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="赛事级别" style="display: flex;flex-direction: column" prop="competition_level">
            <el-select size="mini"  v-model="form.competition_level" collapse-tags clearable placeholder="请选择" @change="onSelectedLevel($event)">
              <el-option v-for="item in levelType" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="10">
          <el-form-item label="主办方" style="display: flex;flex-direction: column" prop="sponsor">
            <el-input size="mini" v-model="form.sponsor" placeholder="主办方名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="承办方" style="display: flex;flex-direction: column" prop="organizer">
            <el-input size="mini" v-model="form.organizer" placeholder="承办方名称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="10">
          <el-form-item label="报名时间" style="display: flex;flex-direction: column" prop="signup_start_time">
            <el-date-picker
              v-model="time.signup_timerange"
              type="daterange"
              range-separator="至"
              start-placeholder="报名起始日期"
              end-placeholder="报名结束日期"
              size="mini"
              value-format="timestamp"
              @change="selectSingUpTimerange($event)">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="比赛时间" style="display: flex;flex-direction: column" prop="competition_start_time">
            <el-date-picker
              v-model="time.match_timerange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              size="mini"
              end-placeholder="结束日期"
              value-format="timestamp"
              @change="selectCompetitionTimerange($event)">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="赛事封面" style="display: flex;flex-direction: column" prop="thumb">
        <love-element-upload
          :list-type="uploadOption.option1.listType"
          :drag="uploadOption.option1.drag"
          :allow-type="uploadOption.option1.allowType"
          :allow-size="uploadOption.option1.allowSize"
          :disabled="uploadOption.option1.disabled"
          :limit="uploadOption.option1.limit"
          :multiple="uploadOption.option1.multiple"
          :love-path="uploadOption.lovePath"
          :file-list="uploadOption.option1.fileList.image"
          :accept="uploadOption.option1.accept"
          :show-file-list="uploadOption.option1.showFileList"
          @preview="onPreviewThumb"
          @remove="onRemoveThumb"
          @success="onSuccessThumb" />
      </el-form-item>
      <el-form-item label="赛项说明" style="display: flex;flex-direction: column" prop="content">
        <el-input v-model="form.content" :rows="10" type="textarea" autocomplete="off" maxlength="254" show-word-limit placeholder="请输入赛项说明" />
      </el-form-item>
      <el-form-item label="竞赛附件" style="display: flex;flex-direction: column">
        <love-element-upload
          :list-type="uploadOption.option2.listType"
          :drag="uploadOption.option2.drag"
          :allow-type="uploadOption.option2.allowType"
          :allow-size="uploadOption.option2.allowSize"
          :disabled="uploadOption.option2.disabled"
          :limit="uploadOption.option2.limit"
          :multiple="uploadOption.option2.multiple"
          :love-path="uploadOption.lovePath"
          :file-list="uploadOption.option2.fileList.attachment"
          :accept="uploadOption.option2.accept"
          :show-file-list="uploadOption.option2.showFileList"
          :tips="uploadOption.option2.tips"
          @preview="onPreviewAttachment"
          @remove="onRemoveAttachment"
          @success="onSuccessAttachment" />
      </el-form-item>
      <el-form-item label="通知公告" >
        <el-button size="mini" type="primary" @click="handleCreateCompetitionAnnounce" plain >+新增</el-button>
        <el-collapse accordion v-if="announceList.length!=0||newAnnounceList.length!=0">
          <el-collapse-item :key="x.id" :ref="'collapseItem'+x.id"  :name="x.id" v-for="x in announceList">
            <template slot="title">
                <el-input  style="width: 280px" @click.stop="()=>{}" size="mini" v-model="x.title"></el-input>
            </template>
           <div>
               <el-input v-model="x.content"   type="textarea" :rows="10" placeholder="请输入公告内容"></el-input>
           </div>
          </el-collapse-item>
          <el-collapse-item :name="index" :key="x.id" v-for="(x,index) in newAnnounceList">
            <template slot="title">
              <el-input @click.stop="()=>{}" @keydown.stop="()=>{}" @keyup.stop="()=>{}" @keypress.stop="()=>{}" v-model="x.title" style="width: 280px" size="mini" placeholder="请输入公告标题"></el-input>
            </template>
            <el-input v-model="x.content" type="textarea" :rows="10" placeholder="请输入公告内容"></el-input>
          </el-collapse-item>
        </el-collapse>
      </el-form-item>
      <el-form-item label="比赛现场">
        <el-button size="mini" type="primary" @click="handleCreateArticle" plain >+新增</el-button>
        <div class="axj-show-club-main-article-list">
          <div class="axj-show-club-main-article" :key="x.id" v-for="x in articleList">
            <div class="article-title">
              {{x.content}}<div class="edit" @click="handleEditArticle(x.id)">编辑</div>
            </div>
            <div class="article-images">
              <img :src="preViewUrl+y.url" v-for="y in x.Thumbs" :key="y">
            </div>
          </div>
          <div class="axj-show-club-main-article" v-for="x in article.articles" :key="x.id">
            <div class="article-title">
              {{x.content}}<div class="edit" @click="handleEditArticle2(x.content,x.uploadOption)">编辑</div>
            </div>
            <div class="article-images">
              <img :src="y.url" v-for="y in x.uploadOption.option.fileList.attachment" :key="y.id">
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="medium" type="info" @click="handleClose">取消</el-button>
      <axj-button color="#00adb5" size="max" @click="handleSubmit">发布</axj-button>
    </div>
    <article-edit
      :show.sync="article.show"
      @created="handleArticleCreated"
      :is-edit="article.isEdit"
      :article-id="article.articleId"
      :upload-option2="article.uploadOption"
      :content="article.content"
      @updated="handleArticleUpdated"
    />
  </el-dialog>
</template>

<script>
import ArticleEdit from "./component/article-edit";
const defaultForm = {
  status: 0,
  title: '',
  user_id: undefined,
  user_name: '',
  user_avatar: '',
  is_comment: 1,
  thumb: '',
  cover_type: undefined,
  video_url: '',
  signup_start_time: undefined,
  signup_end_time: undefined,
  competition_start_time: undefined,
  competition_end_time: undefined,
  organization_sum: undefined,
  competition_level: undefined,
  content: '',
  limited_people: undefined,
  address: '',
  organizer: '',
  sponsor: '',
  file_sum: 0,
  source_directory: ''
}
export default {
  name: "competition-club-edit",
  components: {ArticleEdit},
  methods:{
    // handleEditAnnounce(id){
    //   // this.$refs['collapseItem'+id].querySelectorAll('input').style.display='flex'
    //   this.$refs['collapseItem'+id][0].$el.querySelector('.title').style.display='none'
    //   this.$refs['collapseItem'+id][0].$el.querySelector('.input-title').style.display='flex'
    //   this.$refs['collapseItem'+id][0].$el.querySelector('.submit').style.display='flex'
    //   this.$refs['collapseItem'+id][0].$el.querySelector('.edit').style.display='none'
    //   this.$refs['collapseItem'+id][0].$el.querySelector('.input-content').style.display='flex'
    //   this.$refs['collapseItem'+id][0].$el.querySelector('.content').style.display='none'
    // },
    handleCreateCompetitionAnnounce(){
      this.newAnnounceList.push({
        title:'',
        content:''
      })
    },
    handleEditArticle(id){
      this.article.articleId=id
      this.article.isEdit=1
      this.article.show=true
    },
    handleEditArticle2(content,uploadOption){
      this.article.articleId=id
      this.article.isEdit=2
      this.article.content=content
      this.article.uploadOption=uploadOption
      this.article.show=true
    },
    handleCreateCompetitionArticle(id){
      for(let x=0;x<this.article.articles.length;x++){
         this.$api.axjExtracurricularApi.competitionClub.createCompetitionArticle({
          competition_id:id,
          content:this.article.articles[x].content
        }).then(res=>{
          this.handleCreateArticleAttachment(this.article.articles[x].uploadOption,res.data.id)
        })
      }
    },
    handleArticleUpdated(){
      this.handleGetArticle(this.competitionId)
      this.article.show=false
    },
    handleArticleCreated(form,uploadOption){
      this.article.articles.push({
        content:form.content,
        uploadOption:uploadOption
      })
      this.article.show=false
    },
    handleClose(){
      this.article= {
        articleId:0,
          show:false,
          articles:[],
          isEdit:0,
          content:"",
          uploadOption:{
        }
      },
        this.articleList=[]
      this.newAnnounceList=[]
      this.announceList=[]
      this.uploadOption= {
        lovePath: {
          module: "extra/competition",
          source_directory: "", // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        option1: {
          listType: "picture-card",
          drag: false,
          multiple: true,
          allowType: ["image/jpg", "image/jpeg", "image/png"],
          disabled: false,
          limit: 1,
          fileList: {
            image: [],
            video: []
          },
          allowSize: 4,
          accept: 'image/*',
          showFileList: true
        },
        option2: {
          listType: "text",
          drag: true,
          multiple: true,
          allowType: ["image/jpg", "image/jpeg", "image/png", "application/pdf", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/x-zip-compressed","application/vnd.openxmlformats-officedocument.wordprocessingml.document","application/vnd.ms-powerpoint","application/vnd.openxmlformats-officedocument.presentationml.presentation","application/msword"],
          disabled: false,
          limit: 9,
          lovePath:{
            module: "extra/showclub",
            source_directory: "",  // this.uid + '_' + Date.parse(new Date()) / 1000
          },
          fileList: {
            remove: [],
            attachment: []
          },
          tips: "仅允许上传图片、PDF、DOC、EXCEL、PPT、ZIP等文档类型。",
          allowSize: 8,
          accept: '*',
          showFileList: true
        }
      }
      this.form=Object.assign({}, defaultForm)
      this.$refs['form'].resetFields();
      this.time= {
        signup_timerange: [],
        match_timerange: []
      }
      this.$emit("update:show",false)
    },
    handleUpdateAnnounce(){
      let list=this.announceList
      for(let x=0;x<list.length;x++){
        this.$api.axjExtracurricularApi.competitionClub.updateAnnounce({
          id:list.id,
          ...list[x]
        }).then(res=>{
          console.log(res)
        },error => {
        })
      }
    },
    handleCreateAnnounce(id){
      let list=this.newAnnounceList
      for(let x=0;x<list.length;x++){
        if(list[x].title!=""&&list[x].content!=""){
          this.$api.axjExtracurricularApi.competitionClub.createAnnounce({
            competition_id:id,
            ...list[x]
          }).then(res=>{
            console.log('createSuccess')
          },error => {
          })
        }
      }
    },
    handleOpen(){
      this.uploadOption.lovePath.source_directory = this.$store.getters.getUser.infoUserUid + '_' + Date.parse(new Date()) / 1000
      // 判断编辑状态
      if (!this.isCreate) {
        // 编辑赛事，使用route中的id获取form
        const id = this.competitionId
        // data 中的 id，记录待使用
        this.id = parseInt(id)
        // 获取赛事数据
        this.handleGetCompetitionData(id)
        // 初始化竞赛附件
        this.handleGetCompetitionAttachment(id)

        //初始化竞赛通知
        this.handleGetCompetitionAnnounce(id)

        //
        this.handleGetArticle(id)
      } else {
        // 发布赛事 form 为 default form
        this.form = Object.assign({}, defaultForm)
      }
    },
    handleGetCompetitionAnnounce(id){
      this.$api.axjExtracurricularApi.competitionClub.listCompetitionClubNotice({
        where: JSON.stringify({
          competition_id: id
        }),
        preload:true
      }).then(res=>{
        this.announceList=res.data.lists
      },error => {

      })
    },
    handleGetArticle(id){
      this.$api.axjExtracurricularApi.competitionClub.listCompetitionClubArticle({
        where: JSON.stringify({
          competition_id: id
        }),
        preload:true
      }).then(res=>{
        this.articleList=res.data.lists
      },error => {
      })
    },
    handleGetCompetitionData(id) {
      this.$api.axjExtracurricularApi.competitionClub.getCompetitionClub(id)
        .then(res=> {
          const data = res.data
          // 常规数据
          this.form = Object.assign({}, this.defaultForm, data)
          // 去掉form中的多余属性
          this.$delete(this.form, 'create_time')
          this.$delete(this.form, 'update_time')
          this.$delete(this.form, 'Count')
          this.$delete(this.form, 'User')
          // 若数据库中已经存放了该赛事的 source directory
          if (data.source_directory != '') {
            // uploadOption 中也使用该 source directory
            this.uploadOption.lovePath.source_directory = data.source_directory
          }
          // 时间参数
          this.time.signup_timerange.push(data.signup_start_time * 1000)
          this.time.signup_timerange.push(data.signup_end_time * 1000)
          this.time.match_timerange.push(data.competition_start_time * 1000)
          this.time.match_timerange.push(data.competition_end_time * 1000)
          // 把头像放入 fileList
          var thumb = {
            name: data.name,
            url: data.thumb.indexOf('http') >= 0 ? data.thumb : this.$store.getters.getResourcePrefix.url + data.thumb
          }
          this.uploadOption.option1.fileList.image.push(thumb)
          // this.uploadOption.option1.fileList = this.uploadOption.option1.fileList.image
        })
    },
    onSelectedLevel(event) {
      this.form.competition_level = event
    },
    onPreviewThumb(file) {
      console.log(file)
      console.log(this.uploadOption.option1.fileList)
    },
    onRemoveThumb(file, fileList) {
      this.form.thumb = ''
      this.uploadOption.option1.fileList.image = []
    },
    onSuccessThumb(response) {
      // 保存返回值
      const file = {
        uid: response.uid,
        name: response.old_name,
        url: response.url,
        status: "success"
      }
      this.form.thumb = response.url
      this.uploadOption.option1.fileList.image[0] = file
    },
    onPreviewAttachment(file) {
      console.log(file)
      console.log(this.uploadOption.option2.fileList)
    },
    onRemoveAttachment(file, fileList) {
      // 若是有 id
      if(file.id){
        // 记录
        this.uploadOption.option2.fileList.remove.push(file.id)
      }
      this.uploadOption.option2.fileList.attachment = fileList.map(item => {
        if (typeof(item.response) != 'undefined') {
          return {
            uid: item.uid,
            name: item.response.old_name,
            url: item.response.url,
            status: item.status
          }
        }
        return item
      })
      console.log(file)
      console.log(fileList)
    },
    onSuccessAttachment(response) {
      // 保存返回值
      const file = {
        uid: response.uid,
        name: response.old_name,
        url: response.url,
        type: response.type,
        status: "success"
      }
      console.log("file", file)
      this.uploadOption.option2.fileList.attachment[this.uploadOption.option2.fileList.attachment.length] = file
    },
    handleSubmit(status) {
      // 表单校验
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          // 补充表单信息
          this.form.status = status
          // uploadOption.lovePath.source_directory 中保存的为赛事的 source_directory
          this.form.source_directory = this.uploadOption.lovePath.source_directory
          // 统计竞赛附件
          this.form.file_sum = this.uploadOption.option2.fileList.attachment.length
          // 检验是否有删除掉的附件
          if(this.uploadOption.option2.fileList.remove) {
            this.deleteAttachment()
          }
          // 去掉头像 url 前缀
          this.form.thumb = this.uploadOption.option1.fileList.image[0].url.slice(this.$store.getters.getResourcePrefix.url.length)
          // 创建赛事时
          if (this.isCreate) {
            this.form.user_id = this.$store.getters.getUser.infoUserUid
            this.form.user_name = this.$store.getters.getUser.uname
            this.form.user_avatar = this.$store.getters.getUser.avatar
            this.id = await this.handleCreateCompetition(this.form)
            await this.handleCreateAttachment(this.id)
            this.handleCreateAnnounce(this.id)
            if(this.article.articles.length>0){
              this.handleCreateCompetitionArticle(this.id)
            }
            this.$nextTick(()=> {
              this.$emit('created')
            })
          } else {
            await this.handleUpdateCompetition(this.form)
            await this.handleUpdateCompetitionStatus(this.form)
            await this.handleCreateAttachment(this.id)
            this.handleUpdateAnnounce(this.id)
            this.handleCreateAnnounce(this.id)
            if(this.article.articles.length>0){
              this.handleCreateCompetitionArticle(this.id)
            }
            this.$nextTick(()=> {
              this.$emit('updated')
            })
            console.log(111)
          }
        }
      })
      console.log(this.form)
    },
    handleCloseSubmit() {
      // 取消修改
      this.$nextTick(()=> {
        this.$router.go(-1)
      })
    },
    handleCreateArticle(){
      // this
      this.article.isEdit=0
      this.article.show=true
    },
    handleCreateCompetition(form) {
      return new Promise((resolve, reject)=> {
        this.loading = true
        this.$api.axjExtracurricularApi.competitionClub.createCompetitionClub(form)
          .then(res=> {
            this.$notify({
              message: form.status == 0 ? '保存成功!' : '赛事已成功发布!',
              type: 'success',
              duration: 2000
            })
            this.loading = false
            resolve(res.data.id)
          })
          .catch(err => {
            this.$notify.error({
              message: '赛事发布失败，请重试!',
              duration: 2000
            })
            this.loading = false
            reject(err)
          })
      })
    },
    handleUpdateCompetition(form) {
      return new Promise((resolve, reject)=> {
        // 修改赛事内容
        this.loading = true
        this.$api.axjExtracurricularApi.competitionClub.updateCompetition(form)
          .then(res=> {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    handleUpdateCompetitionStatus(form) {
      return new Promise((resolve, reject)=> {
        // 如果 thumb_sum 等从 非0 再修改为 0 的时候就需要用 where 修改了
        this.$api.axjExtracurricularApi.competitionClub.updateCompetition({
          id: form.id,
          where: JSON.stringify({
            status: form.status,
            is_comment: form.is_comment
          })
        })
          .then(res=> {
            this.$notify({
              message: form.status == 0 ? '保存成功!' : '赛事修改成功!',
              type: 'success',
              duration: 2000
            })
            this.loading = false
            resolve(res)
          })
          .catch(err => {
            this.$notify.error({
              message: '修改赛事失败，请重试!',
              duration: 2000
            })
            this.loading = false
            reject(err)
          })
      })
    },
    selectSingUpTimerange(event) {
      this.form.signup_start_time = event[0] / 1000
      this.form.signup_end_time = event[1] / 1000
    },
    selectCompetitionTimerange(event) {
      console.log("event is ", event)
      this.form.competition_start_time = event[0] / 1000
      this.form.competition_end_time = event[1] / 1000
    },
    // 附件相关
    // 获取竞赛附件
    handleGetCompetitionAttachment(id) {
      this.$api.axjExtracurricularApi.competitionClub.getCompetitionFile({
        where: JSON.stringify({
          competition_id: id
        })
      })
        .then(res=> {
          this.uploadOption.option2.fileList.attachment = [] // 先置空
          this.uploadOption.option2.fileList.attachment = res.data.lists.map(item=> {
            let attachment = {
              id: item.id,
              name: item.name,
              url: item.url,
              type: item.type
            }
            if (!(item.url.indexOf('http') >= 0)) {
              attachment.url = this.$store.getters.getResourcePrefix.url + attachment.url
            }
            return attachment
          })
        })
        .catch(err=> {
          console.log(err)
        })
    },
    handleCreateArticleAttachment(uploadOption,id) {
        for(var i=0; i<uploadOption.option.fileList.attachment.length; i++) {
          // 若是没有 id，则创建，有的代表数据库中已有该文件
          if (!(uploadOption.option.fileList.attachment[i].id)) {
            let attachment = {
              article_id: id,
              type: uploadOption.option.fileList.attachment[i].type ? uploadOption.option.fileList.attachment[i].type : 'Unknown',
              name: uploadOption.option.fileList.attachment[i].name,
              user_id: this.$store.getters.getUser.infoUserUid,
              user_name: this.$store.getters.getUser.uname,
              user_avatar: this.$store.getters.getUser.avatar,
              status: 1,
              url: uploadOption.option.fileList.attachment[i].url.slice(this.$store.getters.getResourcePrefix.url.length)
            }
            this.$api.axjExtracurricularApi.competitionClub.createCompetitionArticleAttachments(attachment)
          }
        }
    },
    handleCreateAttachment(id) {
      return new Promise((resolve, reject)=> {
        for(var i=0; i<this.uploadOption.option2.fileList.attachment.length; i++) {
          // 若是没有 id，则创建，有的代表数据库中已有该文件
          if(!(this.uploadOption.option2.fileList.attachment[i].id)){
            let attachment = {
              competition_id: id,
              type: this.uploadOption.option2.fileList.attachment[i].type?this.uploadOption.option2.fileList.attachment[i].type:'Unknown',
              name: this.uploadOption.option2.fileList.attachment[i].name,
              user_id :this.$store.getters.getUser.infoUserUid,
              user_name :this.$store.getters.getUser.uname,
              user_avatar :this.$store.getters.getUser.avatar,
              status: 1,
              url: this.uploadOption.option2.fileList.attachment[i].url.slice(this.$store.getters.getResourcePrefix.url.length)
            }
            this.createAttachment(attachment)
          }
          resolve()
        }
      })
    },
    createAttachment(obj) {
      this.$api.axjExtracurricularApi.competitionClub.createCompetitionFile(obj)
        .then(res=> {
          this.$notify({
            title: '成功',
            message: '附件创建成功',
            type: 'success',
            duration: 2000
          })
        })
    },
    deleteAttachment() {
      for(var i=0; i<this.uploadOption.option2.fileList.remove.length; i++) {
        console.log(this.uploadOption.option2.fileList.remove[i])
        this.$api.axjExtracurricularApi.competitionClub.deleteCompetitionFile(this.uploadOption.option2.fileList.remove[i])
          .then(res=> {
            console.log("删除附件成功")
          })
          .catch(err=> {
            console.log("删除附件失败")
          })
      }
    }
  },
  data(){
    return{
      article:{
        articleId:0,
        show:false,
        articles:[],
        isEdit:0,
        content:"",
        uploadOption:{

        }
      },
      articleList:[],
      announceList:[],
      newAnnounceList:[],
      showCompetition:false,
      // 记录赛事唯一id
      id: undefined,
      form: Object.assign({}, defaultForm),
      // love element upload 上传文件组件参数
      uploadOption: {
        lovePath: {
          module: "extra/competition",
          source_directory: "", // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        option1: {
          listType: "picture-card",
          drag: false,
          multiple: true,
          allowType: ["image/jpg", "image/jpeg", "image/png"],
          disabled: false,
          limit: 1,
          fileList: {
            image: [],
            video: []
          },
          allowSize: 4,
          accept: 'image/*',
          showFileList: true
        },
        option2: {
          listType: "text",
          drag: true,
          multiple: true,
          allowType: ["image/jpg", "image/jpeg", "image/png", "application/pdf", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/x-zip-compressed","application/vnd.openxmlformats-officedocument.wordprocessingml.document","application/vnd.ms-powerpoint","application/vnd.openxmlformats-officedocument.presentationml.presentation","application/msword"],
          disabled: false,
          limit: 9,
          lovePath:{
            module: "extra/showclub",
            source_directory: "",  // this.uid + '_' + Date.parse(new Date()) / 1000
          },
          fileList: {
            remove: [],
            attachment: []
          },
          tips: "仅允许上传图片、PDF、DOC、EXCEL、PPT、ZIP等文档类型。",
          allowSize: 8,
          accept: '*',
          showFileList: true
        }
      },
      levelType: [{
        value: 0,
        label: '国家级'
      }, {
        value: 1,
        label: '省级'
      }, {
        value: 2,
        label: '校级'
      }, {
        value: 3,
        label: '其他'
      }],
      // web view preview
      webPreview: false,
      // loading
      loading: false,
      // 数据验证
      rules: {
        title: [
          { required: true, message: '赛事名称不能为空', trigger: 'change' }
        ],
        thumb: [
          { required: true, message: '请上传赛事封面', trigger: 'blur,change' }
        ],
        competition_level: [
          { required: true, message: '请选择赛事级别', trigger: 'change' }
        ],
        sponsor: [
          { required: true, message: '请填写主办方', trigger: 'change' }
        ],
        organizer: [
          { required: true, message: '请填写承办方', trigger: 'change' }
        ],
        competition_start_time: [
          { type: 'date',required: true, message: '请选择报名时间', trigger: 'change' }
        ],
        signup_start_time: [
          { type: 'date',required: true, message: '请选择比赛时间', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请填写赛项说明', trigger: 'change' }
        ],
      },
      time: {
        signup_timerange: [],
        match_timerange: [],
      }
    }
  },
  computed:{
    preViewUrl(){
      return this.$common.SystemConfig.PreViewUrl
    }
  },
  props:{
    show:{
      type:Boolean,
      default:false
    },
    isCreate:{
      type:Boolean,
      default:false
    },
    competitionId:{
      type:Number,
      default:0
    }
  },
  watch:{
    show(v){
      this.showCompetition=v
    }
  },
}
</script>

<style scoped lang="scss">
.competition-club-edit{
    .dialog-footer{
      margin-top: -10px;
    }
  .axj-show-club-main-article-list{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    .axj-show-club-main-article{
      width: 630.888px;
      margin-right: 10px;
      box-shadow: 0 2px 2px rgba(0, 0, 0, .08), 0 0 4px rgba(0, 0, 0, .04);
      margin-top: 10px;
      padding-left: 10px;
      .article-title{
        display: flex;
        .edit{
          color: #409eff;
          cursor: pointer;
          margin-left: auto;
          margin-right: 20px;
        }
      }
      img{
        margin-right: 10px;
        width: 55px;
        height: 55px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-extracurricular/axj-competition-club/action/competition-club-edit.vue